import { createContext } from 'react';

const LastSearchTermsContext = createContext();

export default LastSearchTermsContext;
